import axios from 'axios'
import {jsonHeader, wwwFormHeader} from '@/helpers/axiosHeaders'
import Vue from 'vue'
import qs from "qs";
import { addIds, buildSectionUrl, createSectionFormData, updateSectionState } from '../../../helpers/util/helper';

const state = {
    sections: [],
    sectionsLock: [],
    selectSections: [],
    topSections: [],
    topSectionsStaff: [],
    items: [],
    isLoadSections: false,
    isLoadNotifyData: false,
    notifyData: {
        count: 0
    },
    isLoadItems: false,
    isLoadNextPage: true,
    isLoadEditRule: false,
    selectedFilterRuleType: 0,
    itemsPage: 1,
    scrollTop: 0,
    editSection: [],
    editItem: [],
    cursorPositionObj: {
        scrollTop: 0,
        stringNum: 0,
        offsetX: 0,
        strongElem: false,
    },
    useShortcut: false,
    previousSection: {
        top: {
           id: false
        } ,
        second: {
            id: false
        }
    },
    isSearch: false,
    isSearchPrev: false,
    searchStr: '',
    searchInputValue:'',
    openedRule: {},
    rolled: false,
    deactivatedItems: 0,
    canDrag: false,
    marks: [],
    tumblers: {
        editable: {
            value: false,
            name: 'editable',
        },
		schemeEditable: {
            value: false,
            name: 'schemeEditable',
        },
        notify: {
            value: false,
            name: 'notify',
        },
        notifySms: {
            value: false,
            name: 'notifySms',
        },
        staffEditable: {
            value: false,
            name: 'staffEditable',
        },
        contactEditable: {
            value: false,
            name: 'contactEditable',
        },
        lock: {
            value: false,
            name: 'finally',
        },
        finally: {
            value: false,
            name: 'finally',
        },
		zoom: {
            value: false,
            name: 'zoom',
        },
        screencast: {
            value: false,
            name: 'screencast',
        },
    },
    readerRights:{

    },
    writerRights: {
        'subsectionAddEdit': true,
        'subsectionDrag': false,
        'ruleEdit': true,
        'ruleAdd': true,
        'deletedShow': false,
        'ruleDeactivate': true,
        'staffSettings': true,
        'logsShow': true,
    },
    blockEdit: {
        status: false,
        user: {},
        action: false,
    },
    blockEditTimer: false,
    openSearchField: false,
    hasSelectedSection: false,
    sectionsAxiosCancelTokenSource: false,
    isEdit: false,
    closeSearch: true,
    ruleTypesToSearch: JSON.parse(sessionStorage.getItem('ruleTypesToSearch')) || [1, 2, 4],
    sectionToSearch:  sessionStorage.getItem('sectionToSearch') || undefined,
    ruleTypeError: false,
    ruleTypeRepeatError: false,
    newSubSectionLocation: false,
    tempSections: [],
}
const getters = {
    getTopSections(state){
        let items = [];
        for(let i in state.topSections){
            let item = {...state.topSections[i]}
            item.updated = !!state.marks.find(sect => sect.macro === item.id);
            items.push(item);
        }
        return items
    },
    getSections(state){
        return state.sections;
    },
    getSelectSections(state){
        return state.selectSections
    },
    getItems(state) {
        return Object.keys(state.items).map(key => {
            const item = state.items[key];
            return {
                ...item,
                updated: item.active && state.marks.some(sect => sect.rule === item.id)
            };
        });
    },
    getItemFiles(state){
        return state.editItem.files
    },
    getCurrentTopSect: state => id => {
        return state.topSections.find(sect => sect.id === id);
    }
}
const mutations = {
    TOGGLE_RULE_TYPE_TO_SEARCH(state, id) {
        const index = state. ruleTypesToSearch.indexOf(id);
        index === -1 
            ? state.ruleTypesToSearch.push(id) 
            : state.ruleTypesToSearch.splice(index, 1);
        sessionStorage.setItem('ruleTypesToSearch', JSON.stringify(state.ruleTypesToSearch));
        state.ruleTypeError = false;
        state.ruleTypeRepeatError = false;
    },
    SET_RULES_TYPE_TO_SEARCH(state, data ) {
        state.ruleTypesToSearch = data;
    },
    SET_SECTION_TO_SEARCH(state, sectionId) {
        state.sectionToSearch = sectionId;
        if (sectionId == undefined) {
            sessionStorage.removeItem('sectionToSearch');
        } else {
            sessionStorage.setItem('sectionToSearch', sectionId);
        }
    },
    SET_RULE_TYPE_ERROR(state, error) {
        state.ruleTypeError = error;
    },
    SET_RULE_TYPE_REPEAT_ERROR(state, error) {
        state.ruleTypeRepeatError = error;
    },
    setFilterRuleType(state, data) {
        Vue.set(state,'selectedFilterRuleType', data);
    },
    setSubtitle(state, data) {
        let activeIndex = 0;
        state.topSections.forEach((sect, index) => {
            if (sect.id === window.app.$route.params.id) {
                activeIndex = index;
            }
        });
        Vue.set(state.topSections[activeIndex],'subtitle', data);
    },
    setSelectedSection(state, data) {
        Vue.set(state,'hasSelectedSection', data);
    },
    setPreviousSection(state, data) {
        Vue.set(state.previousSection.top,'id', data.topSection);
        Vue.set(state.previousSection.second,'id', data.section);
    },

    openSearchField(state, data){
        Vue.set(state,'openSearchField', data);
    },
    setTopSections(state, data){
        if (typeof data === 'object' && data.items !== undefined) {
            let items = [];
            let itemsLock = [];
            for(let item of data.items){
                if(!item.lock){
                    items.push(item)
                } else {
                    itemsLock.push(item)
                }
            }
            Vue.set(state,'topSections', items);
            if(data.method){
                Vue.set(state,'sectionsLock', itemsLock);
            }
        }
    },
    setTopSectionsStaff(state, data){
        if (typeof data === 'object' && data.items !== undefined) {
            let items = [];
            let itemsLock = [];
            for(let item of data.items){
                if(!item.lock){
                    items.push(item)
                } else {
                    itemsLock.push(item)
                }
            }
            Vue.set(state,'topSectionsStaff', items);
            Vue.set(state,'sectionsLock', itemsLock);
        }
    },

    setNotifyData(state, data){
        if (typeof data === 'object') {
            Vue.set(state,'notifyData', data);
        }
    },
    toggleTumbler(state, data){
        state.tumblers[data].value = !state.tumblers[data].value;
    },
    tumblerOff(state, data){
        state.tumblers[data].value = false;
    },
    tumblerSet(state, data){
        state.tumblers[data.name].value = data.value;
    },
    removeRule(state, data){
        for (let i in state.items) {
            if(state.items[i].id == data){
                state.items.splice(i, 1);
            }
        }
    },
    setCheckEditLoader(state, data){
        for (let i in state.items) {
            if(state.items[i].id == data.id){
                state.items[i].isCheckEdit = data.value;
            }
        }
    },
    changeRule(state, data) {
        for (let i in state.items) {
            if(state.items[i].id == data.id){
                data.opened = state.items[i].opened;
                Vue.set(state.items, i, data);
                state.openedRule = state.items[i];
            }
        }
    },
    changeFiles(state, data) {
        state.editItem.files = data;
    },
    addRule(state, data) {
        state.items.push(data);
    },
    setItems(state, data) {
        if (typeof data === 'object' && data.items !== undefined) {
            state.items = [...data.items];
        } else {
            state.items = [];
        }
    },
    addItems(state, data) {

        if (typeof data === 'object' && data.items !== undefined) {

            state.items = [...state.items, ...data.items];

        } else {

             state.items = [];
             
        }
        
    },
    setItemsForce(state, data) {
        state.items = [data]
    },
    setItem(state, data) {
        if (typeof data === 'object' && data.items !== undefined) {
            let index = state.items.findIndex(sect => sect.id === data.items.id);
            Vue.set(state.items, index, data.items);
        }
    },
    setItemsLocal(state, data) {
        state.items = data.items;
    },
    setMark(state, data) {
        state.marks = data.items;
    },
    setSections(state, data) {
        if (typeof data === 'object' && data.items !== undefined) {
            Vue.set(state, 'sections', Array.isArray(data.items) ? data.items : []);
            Vue.set(state, 'selectSections', Array.isArray(data.items) ? data.items : []);
        } else {
            Vue.set(state, 'sections', []);
            Vue.set(state, 'selectSections', []);
        }
    },
    setItemFiles(state, data) {
        if (typeof data === 'object' && data.items !== undefined) {
            Vue.set(state.editItem,'files', data.items);
        }
    },
    setLoadItems(state, data) {
        state.isLoadItems = data;
    },
    setCursorPositionObj(state, data){
        state.cursorPositionObj = data;
    },
    setLoadEditRule(state, data) {
        state.isLoadEditRule = data;
    },
    setUseShortcut(state, data) {
        state.useShortcut = data;
    },
    setLoadSections(state, data) {
        state.isLoadSections = data;
    },
    setLoadNotifyData(state, data) {
        state.isLoadNotifyData = data;
    },
    setSectionsAxiosCancelTokenSource(state, data) {
        state.sectionsAxiosCancelTokenSource = data;
    },
    setEditSection(state, data) {
        state.editSection = data;
    },
    setNewSubSectionLocation(state, data) {
        state.newSubSectionLocation = data;
    },
    setEditItem(state, data) {
        if (typeof(data) !== 'undefined') {
            if(typeof(data.finally) !== 'undefined'){
                Vue.set(state.tumblers.finally, 'value', data.finally);
            }
            Vue.set(state, 'editItem', data);
        }
    },
    setNewPage(state) {
        Vue.set(state, 'items', []);
        state.itemsPage = 1;
        state.isLoadNextPage = true;
    },
    incrementPage(state) {
        state.itemsPage++;
    },
    isLoadNextPage(state, data) {
        state.isLoadNextPage = data;
    },
    removeFile(state, data) {
        if(state.editItem.files){
            for(let f in state.editItem.files){
                if(state.editItem.files[f].id === data){
                    state.editItem.files.splice(f , 1);
                }
            }
        }
    },
    addFile(state, data) {
        let files = typeof state.editItem.files === 'object' ? [...state.editItem.files] : []
        files.push(data)
        Vue.set(state.editItem, 'files', files);
    },
    setIsSearch(state, data){
        state.isSearch = data;
    },
    setIsSearchPrev(state, data){
        state.isSearchPrev = data;
    },
    toggleRule(state, data){
        state.items[data].opened = !state.items[data].opened;
    },
    closeRules(state, data){
        state.items[data].opened = false;
    },
    openRule(state, data){
        for (let i in state.items) {
            if(state.items[i].id == data){
                state.items[i].opened = true;
            }
        }
    },
    toggleRolled(state){
        state.rolled = false;
    },
    removeSection(state, data){
        const removeFromSections = (sections, targetId) => {
            for (let i = sections.length - 1; i >= 0; i--) {
                if (sections[i].id === targetId) {
                    sections.splice(i, 1);
                    return true;
                }
                if (sections[i].sections && sections[i].sections.length > 0) {
                    if (removeFromSections(sections[i].sections, targetId)) {
                        return true;
                    }
                }
            }
            return false;
        };
        
        removeFromSections(state.sections, data);
    },
    updateSubSections(state, { parentId, newSubSections }) {
        const parent = state.sections.find(s => s.id === parentId);
        if (parent) {
            parent.sections = newSubSections;
        }
    },
    removeTopSection(state, data){
        for (let i in state.topSections) {
            if(state.topSections[i].id == data){
                state.topSections.splice(i, 1);
            }
        }
    },
    deleteMark(state, data){
        for (let i in state.marks) {
            if(state.marks[i].rule == data){
                state.marks.splice(i, 1);
            }
        }
    },
    setDeactivatedItems(state, data){
        state.deactivatedItems = data;
    },
    setScrollTop(state,data){
        state.scrollTop = data;
    },
    setSearchStr(state, data){
        state.searchStr = data;
    },
    setSearchInputValue(state, payload) {
        state.searchInputValue = payload;
    },
    setOpenedRule(state, data){
        state.openedRule = state.items[data];
        if(typeof(state.items[data].screencast) !== 'undefined'){
            Vue.set(state.tumblers.screencast, 'value', state.items[data].screencast);
        }
    },
    setOpenRule(state, data){
        state.openedRule = data;
    },
    toggleDrag(state, data){
        state.canDrag = !state.canDrag;
    },
    setTimerBlockEdit(state, data){
        state.blockEditTimer = data;
    },
    setBlockEdit(state,data){
        state.blockEdit = data;
    },
    clearBlockEdit(state,data){
        if(state.blockEditTimer){
            clearInterval(state.blockEditTimer);
        }
        state.blockEdit = {
            status: false,
            user: {},
            action: false,
        };
    },
    setItemTextLoad(state, data){
        if (typeof(data.index) !== 'undefined') {
            state.items[data.index].texLoading = data.status;
        }
    },
    addChildId(state, data) {
        for (let i in state.topSections) {
            if(state.topSections[i].id == data.pid){
                if (typeof(state.topSections[i].subsections) === 'undefined') {
                    state.topSections[i].subsections = [];
                }

                state.topSections[i].subsections.push(data.id + '');
                break;
            }
        }
    },
    setIsEdit(state, data) {
        state.isEdit = data;
    },
    setNotifyError(state, data) {
        state.notifyError = data;
    },
    closeSearch(state, data) {
        state.closeSearch = data;
    },
    setScreencast(state, data) {
        state.openedRule.creencast = data;
    },
    setTempSections(state, data) {
        if (Array.isArray(data)) {
            state.tempSections = data;
        } else {
            state.tempSections = [];
        }
    }
}
const actions = {
    setRulesTypeToSearch({ commit }, data) {
        commit('SET_RULES_TYPE_TO_SEARCH', data);
    },
    toggleRuleTypeToSearch({ commit }, id) {
        commit('TOGGLE_RULE_TYPE_TO_SEARCH', id);
    },
    triggerRuleTypeError(context, error) {
        if(context.state.ruleTypeError){
            context.commit('SET_RULE_TYPE_REPEAT_ERROR', !error);
            setTimeout(() => {
                context.commit('SET_RULE_TYPE_REPEAT_ERROR', error);
            }, 50);
        }else{
            context.commit('SET_RULE_TYPE_ERROR', error);
        }
    },
    setSectionToSearch({ commit }, sectionId) {
        commit('SET_SECTION_TO_SEARCH', sectionId);
    },
    setEditItem(context, data) {
        return new Promise((resolve, reject) => {
            context.commit('setEditItem', data);
            resolve();
        });
    },
    getTopSection(context, data) {
        return new Promise((resolve, reject) => {
                    context.commit('setLoadSections', true);

                    let params =  {
                        type: 'topSections',
                        isStaffPage: data && data.isStaffPage ? 'Y' : 'N'
                    };

                    axios.get(process.env.VUE_APP_API_PATH + '/rules/section/', {
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8',
                            'Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false
                        },
                        withCredentials: true,
                        params: params,
                        paramsSerializer: function (params) {
                            return qs.stringify(params, {arrayFormat: 'repeat'})
                        },
                    }).then(response => {
                        context.commit('setLoadSections', false);
                        if (typeof response.data === 'object' && +response.data.error === 0) {

                            if(data && data.isStaffPage){
                                context.commit('setTopSectionsStaff', response.data.result);
                            } else {
                                context.commit('setTopSections', response.data.result);
                            }
                            if(response.data.result.deactivatedEls){
                                context.commit('setDeactivatedItems', response.data.result.deactivatedEls);
                            }
                        } else {
                            if (+response.data.error === 401) {                                
                                if (response.data.result.user.login === null) {
                                    context.dispatch('auth/logout', {}, {root: true})
                                } else {
                                    context.commit('auth/setIsNoSuccessSection', {}, {root: true})
                                }
                            }
                        }

                        resolve();
                    }).catch(function (error) {
                        context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                        context.commit('setLoadSections', false);
                        reject();
                    });
            //}
        });
    },
    getNotifyData(context, data) {
        return new Promise((resolve, reject) => {
                    context.commit('setLoadNotifyData', true);

                    let params =  {
                        type: 'getNotifyData',
                        section: data.section,
                        item: data.item,
                        isNew: data.isNew
                    };

                    axios.get(process.env.VUE_APP_API_PATH + '/rules/section/', {
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8',
                            'Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false
                        },
                        withCredentials: true,
                        params: params,
                        paramsSerializer: function (params) {
                            return qs.stringify(params, {arrayFormat: 'repeat'})
                        },
                    }).then(response => {
                        context.commit('setLoadNotifyData', false);
                        if (typeof response.data === 'object' && +response.data.error === 0) {
                            context.commit('setNotifyData', response.data.result);
                        } else {
                            if (+response.data.error === 401) {
                                if (response.data.result.user.login === null) {
                                    context.dispatch('auth/logout',{},{root:true})
                                } else {
                                    context.commit('auth/setIsNoSuccessSection', {}, {root: true})
                                }
                            }
                        }

                        resolve(response.data.result);
                    }).catch(function (error) {
                        context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                        context.commit('setLoadNotifyData', false);
                        reject();
                    });
            //}
        });
    },
    getMarks(context, data) {
        return new Promise((resolve, reject) => {

            axios.get(process.env.VUE_APP_API_PATH + '/rules/mark/', {
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false
                },
                withCredentials: true
            }).then(response => {

                if (+response.data.error === 401 && response.data.result.user.login === null) {
                    context.dispatch('auth/logout', {}, {root: true});
                }

                if (typeof response.data === 'object' && +response.data.error === 0) {
                    context.commit('setMark', response.data.result);
                }
                resolve();
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject();
            });
        });
    },
    checkEditItem(context, data) {
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_PATH + '/rules/element/'+data.id+'/', {
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false
                },
                withCredentials: true,
                params: {
                    type: "checkBlockEdit"
                },
                paramsSerializer: function (params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if (+response.data.error === 401 && response.data.result.user.login === null) {
                    context.dispatch('auth/logout', {}, {root: true});
                    resolve();
                }
                if (typeof response.data === 'object' && +response.data.error === 0) {
                    context.commit('setBlockEdit', response.data.result);
                    resolve(response.data.result);
                } else {
                    resolve(state.blockEdit);
                }
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject();
            });
        });
    },
    setTimerBlockEdit(context, data){
        axios.put(process.env.VUE_APP_API_PATH+'/rules/element/' + data.id,{}, {
            withCredentials: true,
            headers: {'Content-Type': 'application/json;charset=utf-8','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
            params: {
                type: "setBlockEdit"
            },
            paramsSerializer: function (params) {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            },
        })
        let blockEditTimer = setInterval(()=>{
            axios.put(process.env.VUE_APP_API_PATH+'/rules/element/' + data.id,{}, {
                withCredentials: true,
                headers: {'Content-Type': 'application/json;charset=utf-8','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                params: {
                    type: "setBlockEdit"
                },
                paramsSerializer: function (params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            })
        },60000);
        context.commit('setTimerBlockEdit', blockEditTimer);
    },
    clearBlockEdit(context, data){
        return new Promise((resolve, reject) => {
            context.commit('clearBlockEdit');
            axios.put(process.env.VUE_APP_API_PATH+'/rules/element/' + data.id, {},{
                withCredentials: true,
                params: {
                    type: "clearBlockEdit"
                },
                paramsSerializer: function (params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
                headers: {'Content-Type': 'application/json;charset=utf-8','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
            });
        })
    },
    deleteMarks(context, data) {
        return new Promise((resolve, reject) => {
            context.commit('deleteMark', data.id);
            axios.delete(process.env.VUE_APP_API_PATH + '/rules/mark/'+data.id+'/', {
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false
                },
                withCredentials: true
            }).then(response => {
                if (+response.data.error === 401 && response.data.result.user.login === null) {
                    context.dispatch('auth/logout', {}, {root: true});
                }
                resolve();
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject();
            });
        });
    },
    getSubsectionOption(context, data){
        return new Promise((resolve, reject) => {

                    let params =  {
                        type: 'secondSections',
                        id: data.id,
                    };

                    axios.get(process.env.VUE_APP_API_PATH + '/rules/section/', {
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8',
                            'Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false
                        },
                        withCredentials: true,
                        params: params,
                        paramsSerializer: function (params) {
                            return qs.stringify(params, {arrayFormat: 'repeat'})
                        },
                    }).then(response => {
                        if (typeof response.data === 'object' && +response.data.error === 0) {
                            resolve(response.data.result.items);
                        } else {
                            if (+response.data.error === 401) {
                                if (response.data.result.user.login === null) {
                                    context.dispatch('auth/logout',{},{root:true})
                                } else {
                                    context.commit('auth/setIsNoSuccessSection', {}, {root: true})
                                }
                            }
                        }
                        resolve();
                    }).catch(function (error) {
                        context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                        reject();
                    });
                //}
            //}
        });
    },
    getSections(context, data) {
        
        return new Promise((resolve, reject) => {
            if(data.id !== 'lock'){
                context.commit('setSections', {items: []});

                if (state.isLoadSections) {
                    context.commit('setLoadSections', false);
                    if (state.sectionsAxiosCancelTokenSource !== false) {
                        state.sectionsAxiosCancelTokenSource.cancel();
                    }
                }

                if (!state.isLoadSections) {
                    context.commit('setLoadSections', true);

                    let params =  {
                        type: 'secondSections',
                        id: data.id,
                    };

                    let request = axios.CancelToken.source();
                    context.commit('setSectionsAxiosCancelTokenSource', request);

                    axios.get(process.env.VUE_APP_API_PATH + '/rules/section/', {
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8',
                            'Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false
                        },
                        cancelToken: state.sectionsAxiosCancelTokenSource.token,
                        withCredentials: true,
                        params: params,
                        paramsSerializer: function (params) {
                            return qs.stringify(params, {arrayFormat: 'repeat'})
                        },
                    }).then(response => {
                        context.commit('setSectionsAxiosCancelTokenSource', false);
                        context.commit('setLoadSections', false);
                        if (typeof response.data === 'object' && +response.data.error === 0) {
                            context.commit('setSections', response.data.result);
                            if(response.data.result.deactivatedEls){
                                context.commit('setDeactivatedItems', response.data.result.deactivatedEls);
                            }
                            //context.commit('isLoadNextPage', response.data.result.isLoadNextPage);
                        } else {
                            if (+response.data.error === 401) {
                                if (response.data.result.user &&  response.data.result.user.login === null) {
                                    context.dispatch('auth/logout',{},{root:true})
                                } else {
                                    context.commit('auth/setIsNoSuccessSection', {}, {root: true})
                                }
                            }
                        }
                        resolve();
                    }).catch(function (error) {
                        resolve();
                    });
                    //}
                }
            } else {
                resolve();
            }

        });
    },
    getTempSections(context, data) {
        
        return new Promise((resolve, reject) => {

            if (!state.isLoadSections) {
                let params =  {
                    type: 'secondSections',
                    id: data.id,
                };

                let request = axios.CancelToken.source();
                context.commit('setSectionsAxiosCancelTokenSource', request);

                axios.get(process.env.VUE_APP_API_PATH + '/rules/section/', {
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8',
                        'Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false
                    },
                    cancelToken: state.sectionsAxiosCancelTokenSource.token,
                    withCredentials: true,
                    params: params,
                    paramsSerializer: function (params) {
                        return qs.stringify(params, {arrayFormat: 'repeat'})
                    },
                }).then(response => {
                    context.commit('setSectionsAxiosCancelTokenSource', false);
                    context.commit('setLoadSections', false);
                    context.commit('setTempSections', response.data.result.items || []);
                    resolve();
                }).catch(function (error) {
                    resolve();
                });
                //}
            }

        });
    },

    getDeactivatedItems(context, data){
        return new Promise((resolve, reject) => {
            context.commit('setLoadSections', true);
            let params =  {
                type: 'deactivatedItems',
            };
            axios.get(process.env.VUE_APP_API_PATH + '/rules/section/', {
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false
                },
                withCredentials: true,
                params: params,
                paramsSerializer: function (params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if (typeof response.data === 'object' && +response.data.error === 0) {
                    //context.commit('setDeactivatedItems', response.data.result);
                } else {
                    if (+response.data.error === 401) {
                        if (response.data.result.user.login === null) {
                            context.dispatch('auth/logout',{},{root:true})
                        } else {
                            context.commit('auth/setIsNoSuccessSection', {}, {root: true})
                        }
                    }
                }
                //context.commit('incrementPage');
                resolve();
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject();
            });
        });
    },
    setSection(context, data) {
        return new Promise((resolve, reject) => {
            const url = buildSectionUrl(data);
            const formData = createSectionFormData(data);

            axios.post(url, formData, {
                headers: {'Content-Type': 'application/json;charset=utf-8','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
            }).then(response => {
                let id = data.id ? data.id : (+response.data.result.done > 0 ? +response.data.result.done : false);
                
                if (typeof response.data === 'object' && +response.data.error === 0) {
                    updateSectionState(context, data, id);
                    resolve({id: id, error: +response.data.error});
                } else {
                    if (+response.data.error === 401 && response.data.result.user.login === null) {
                        context.dispatch('auth/logout', {}, {root: true});
                    }
                    resolve({id: id, error: +response.data.error});
                }
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                console.log(error);
            });
        });
    },
    removeSection(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/section/'+data.id+'/';
            let formData = new FormData();
            formData.append('type', 'removeSection');
            formData.append('topSection', data.topSection);

            axios.post(url, formData, {
                headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if(response.data.result.done){
                    context.commit('removeSection',data.id);
                }

                if (+response.data.error === 401 && response.data.result.user.login === null) {
                    context.dispatch('auth/logout', {}, {root: true});
                }

                resolve(response);
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                resolve();
            });
        });
    },
    removeTopSection(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/section/'+data.id+'/';
            let formData = new FormData();
            formData.append('type', 'removeTopSection');
            //formData.append('topSection', data.topSection);

            axios.post(url, formData, {
                headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if (+response.data.error === 401 && response.data.result.user.login === null) {
                    context.dispatch('auth/logout', {}, {root: true});
                }
                if(response.data.result){
                    context.commit('removeTopSection',data.id);
                    resolve(true);
                }else{
                    resolve(false);
                }

            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                resolve();
            });
        });
    },
    
    setSectionsSort(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/section/';
            let formData = new FormData();
            formData.append('type', 'setSectionsSort');
            formData.append('topSection', data.activeTopSection);
            formData.append('id', data.id);

            context.commit('setSubtitle', context.state.sections[0].name);

            const ids = addIds(context.state.sections);

            formData.append('ids', JSON.stringify(ids));
            axios.post(url, formData, {
                headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if (+response.data.error === 401 && response.data.result.user.login === null) {
                    context.dispatch('auth/logout', {}, {root: true});
                }
                if (+response.data.error === 403) {
                    context.dispatch('rules/getSections', {id: data.activeTopSection}, {root: true});
                    context.commit('popups/open', {name: context.rootState.popups.items.sectionForbiddenError.name}, {root: true});
                }
                resolve();
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                resolve();
            });
        });
    },
    setTopSectionsSort(context){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/section/';
            let formData = new FormData();
            let ids = [];
            formData.append('type', 'setTopSectionsSort');
            for (let i in context.state.topSections) {
                ids.push(context.state.topSections[i].id);
            }
            formData.append('ids', JSON.stringify(ids));
            axios.post(url, formData, {
                headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if (+response.data.error === 401 && response.data.result.user.login === null) {
                    context.dispatch('auth/logout', {}, {root: true});
                }
                resolve();
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                resolve();
            });
        });
    },
    setRulesSort(context,data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/element/';
            let formData = new FormData();
            let ids = [];
            formData.append('type', 'setRulesSort');
            for (let i in context.state.items) {
                ids.push(context.state.items[i].id);
            }
            if(data.isRemoved){
                formData.append('isRemoved', 'y');
            }
            formData.append('ids', JSON.stringify(ids));
            axios.post(url, formData, {
                headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if (+response.data.error === 401 && response.data.result.user.login === null) {
                    context.dispatch('auth/logout', {}, {root: true});
                }
                resolve(response.data);
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                resolve();
            });
        });
    },
    removeRule(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/element/'+data.id+'/';
            let formData = new FormData();
            formData.append('type', 'removeRule');
            formData.append('forever', data.forever);
            formData.append('section', data.section);
            formData.append('subSection', data.subSection);

            axios.post(url, formData, {
                headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if (+response.data.error === 401 && response.data.result.user.login === null) {
                    context.dispatch('auth/logout', {}, {root: true});
                }
                if (+response.data.error === 403) {
                    context.commit('popups/open', {name: context.rootState.popups.items.sectionForbiddenError.name}, {root: true});
                } else {
                    context.commit('removeRule',data.id);
                }
                let isLast = false;

                if(response.data.result.deactivatedEls !== undefined){
                    context.commit('setDeactivatedItems', response.data.result.deactivatedEls);
                    if(data.forever && response.data.result.deactivatedEls==0){
                        isLast = true;
                    }
                } else if(state.rules.deactivatedItems == 0){
                    isLast = true;
                }
                resolve(isLast);
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                resolve();
            });
        });
    },
    removeRuleAll(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/element/';
            let formData = new FormData();
            formData.append('type', 'removeRuleAll');

            axios.post(url, formData, {
                headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if (+response.data.error === 401 && response.data.result.user.login === null) {
                    context.dispatch('auth/logout', {}, {root: true});
                }
                if(response.data.result.deactivatedEls !== undefined){
                    context.commit('setDeactivatedItems', response.data.result.deactivatedEls);
                }
                resolve();
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                resolve();
            });
        });
    },
    addScreenShot(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/element/';
            let formData = new FormData();
            formData.append('type', 'addScreenShot');
            formData.append('screen', data.value);

            axios.post(url, formData, {
                headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if (+response.data.error === 401 && response.data.result.user.login === null) {
                    context.dispatch('auth/logout', {}, {root: true});
                }
                context.commit('addFile', response.data.result.file);
                resolve(response.data.result.file);

            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                resolve();
            });
        });
    },
    uploadFiles(context, data) {
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/element/';
            axios.post(url,data.formData, {
                headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if(typeof response.data === 'object' && +response.data.error === 0) {
                    for (let f in response.data.result.files){
                        context.commit('addFile', response.data.result.files[f]);
                    }
                    resolve(response.data.result.files);
                } else {
                    if (+response.data.error === 401 && response.data.result.user.login === null) {
                        context.dispatch('auth/logout', {}, {root: true});
                    }
                }
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                console.log(error);
                resolve();
            });
        });
    },
    setRuleTech(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/element/'+data.id;
            let formData = new FormData();
            formData.append('user', data.user);
            formData.append('type', 'saveRuleTech');
            axios.post(url, formData, {
                headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
            }).then(response => {
                resolve();
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                console.log(error);
                resolve();
            });
        });
    },
    setRule(context, data) {
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/element/';
            if(data.id){
                url +=  data.id+'/';
            }
            axios.post(url,data.formData, {
                headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if(typeof response.data === 'object') {
                    if(data.id){
                        if(response.data.result.item.section == data.activeSection){
                            context.commit('changeRule',response.data.result.item);
                        }
                        else{
                            context.commit('removeRule',response.data.result.item.id);
                        }
                        context.commit('setOpenRule',response.data.result.item);
                    }
                    else{
                        if(response.data.result.item.section == data.activeSection){
                            context.commit('addRule',response.data.result.item);
                        }
                    }
                    resolve(response.data.result.item);
                    context.commit('setIsSearch', false);
                    context.commit('setSearchStr', '');
                } else {
                    if (+response.data.error === 401) {
                        if (response.data.result.user.login === null) {
                            context.dispatch('auth/logout',{},{root:true})
                        } else {
                            context.commit('auth/setIsNoSuccessSection', {}, {root: true})
                        }
                    }
                    if (+response.data.error === 403) {
                        context.commit('popups/open', {name: context.rootState.popups.items.sectionForbiddenError.name}, {root: true});
                        resolve();
                    }
                }
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                console.log(error);
                resolve();
            });
        });
    },
    getItems(context, data) {
        return new Promise((resolve, reject) => {
            if (!state.isLoadItems || data.reload) {
                if (data.reload) {
                    context.commit('setNewPage', {status: data.status});
                }
                if (state.isLoadNextPage) {
                    context.commit('setLoadItems', true);

                    let params = {};

                    if (data.search) {
                        context.commit('setIsSearch', true);
                        context.commit('setSearchStr', data.search);
                        params.status = data.status;
                        params.search = data.search;
                        params.ruleType = state.ruleTypesToSearch;
                        params.section = state.sectionToSearch;
                        if (state.ruleTypesToSearch.length === 0) {
                            context.dispatch('triggerRuleTypeError', true);
                            context.commit('setLoadItems', false);
                            return false;
                        }
                    }
                    else if(data.screencast) {
                        params.screencast = 'Y';
                    }
                    else{
                        if(!state.isSearchPrev){
                            context.commit('setIsSearch', false);
                            context.commit('setSearchStr', '');
                        }

                        params =  {
                            type: 'items',
                            page: state.itemsPage,
                            topsect: data.topSect,
                        };
                        if(data.full){
                            params.full = true;
                        }
                    }
                    axios.get(process.env.VUE_APP_API_PATH + '/rules/element/'+data.id+'/', {
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8',
                            'Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false
                        },
                        withCredentials: true,
                        params: params,
                        paramsSerializer: function (params) {
                            return qs.stringify(params, {arrayFormat: 'brackets'})
                        },
                    }).then(response => {
                        if (typeof response.data === 'object' && +response.data.error === 0) {
                            if (data.id === 'removed') {
                                context.commit('addItems', response.data.result);
                            } else {
                                context.commit('setItems', response.data.result);
                            }
                            context.commit('isLoadNextPage', response.data.result.isLoadNextPage);
                        } else {
                            if (+response.data.error === 401) {
                                if (response.data.result.user.login === null) {
                                    context.dispatch('auth/logout',{},{root:true})
                                } else {
                                    context.commit('auth/setIsNoSuccessSection', {}, {root: true})
                                }
                            }
                        }
                        context.commit('setLoadItems', false);
                        context.commit('incrementPage');
                        resolve();
                    }).catch(function (error) {
                        context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                        context.commit('setLoadItems', false);
                        reject();
                    });
                }
            }
        });
    },
    getRemoveItem(context, data) {
        return new Promise((resolve, reject) => {
            let params =  {
                type: 'getItem',
                removed: 'y',
            };
            axios.get(process.env.VUE_APP_API_PATH + '/rules/element/'+data.id+'/', {
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false
                },
                withCredentials: true,
                params: params,
                paramsSerializer: function (params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if (+response.data.error === 401 && response.data.result.user.login === null) {
                    context.dispatch('auth/logout', {}, {root: true});
                }
                context.commit('setItemsForce', response.data.result.items);
                resolve();
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject();
            });
        });
    },
    getRuleText(context, data) {
        return new Promise((resolve, reject) => {
            if(data.item.text != false || typeof(data.item.id) === 'undefined'){
                resolve();
            }
            else{
                context.commit('setItemTextLoad', {index: data.index, status: true});
                let params =  {
                    type: 'getItem',
                    removed: data.removed ? 'y': '',
                    search: context.state.searchStr
                };
                axios.get(process.env.VUE_APP_API_PATH + '/rules/element/'+data.item.id+'/', {
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8',
                        'Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false
                    },
                    withCredentials: true,
                    params: params,
                    paramsSerializer: function (params) {
                        return qs.stringify(params, {arrayFormat: 'repeat'})
                    },
                }).then(response => {
                    if (+response.data.error === 401 && response.data.result.user.login === null) {
                        context.dispatch('auth/logout', {}, {root: true});
                    }
                     context.commit('setItem', response.data.result );
                    context.commit('setItemTextLoad', {index: data.index, status: false});
                    resolve(response.data.result.items);
                }).catch(function (error) {
                    context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                    context.commit('setItemTextLoad', {index: data.index, status: false});
                    reject();
                });
            }
        });
    },
    setScreencast(context, data) {
        return new Promise((resolve, reject) => {
            let params =  {
                type: 'setScreencast',
                value: data.value,
            };
            axios.post(process.env.VUE_APP_API_PATH + '/rules/element/'+data.id+'/', {},{
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false
                },
                withCredentials: true,
                params: params,
                paramsSerializer: function (params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if (+response.data.error === 401 && response.data.result.user.login === null) {
                    context.dispatch('auth/logout', {}, {root: true});
                }
                context.commit('setScreencast', data.value);
                resolve();
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject();
            });

        });
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
